export default __webpack_public_path__ + "static/media/cases9.2c41426c.webp";